// extracted by mini-css-extract-plugin
export default {"wrap":"QP-z","fullWidth":"RP-z","hideOnDesktop":"SP-z","content":"TP-z","hasOpenedNav":"UP-z","crumbsList":"VP-z","dropdownsWrap":"WP-z"};